import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSanitizerService } from '@shared/src/services/url-sanitizer/url-sanitizer.service';

@Injectable()
export class UrlSanitizationInterceptor implements HttpInterceptor {
  constructor(private readonly urlSanitizer: UrlSanitizerService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const sanitizedUrl = this.urlSanitizer.sanitizeUrl(request.url);

    if (!this.urlSanitizer.isUrlSafe(request.url)) {
      throw new Error('Unsafe URL detected in HTTP request');
    }

    const sanitizedRequest = request.clone({
      url: sanitizedUrl,
    });

    return next.handle(sanitizedRequest);
  }
}
